export const RECEIVE_GAS_TOKENS = 1.17;
export const GAS_TOKENS_FEE = 1.18;
